import script from "./show.vue?vue&type=script&setup=true&lang=js"
export * from "./show.vue?vue&type=script&setup=true&lang=js"

import "./show.vue?vue&type=style&index=0&id=073ee1e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073ee1e4"]])

export default __exports__